import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Alert,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import BlockIcon from '@mui/icons-material/Block';
import {useAppDispatch, useAppSelector} from '../../../hooks/redux';
import {closeBillingModal} from '../model/slice';
import {
    selectBillingStatus,
    selectThresholdWarning,
    selectForecastDays,
    selectBillingBalance,
    selectBillingUnit,
} from '../model/selectors';
import {useNavigate} from 'react-router-dom';
import {routes} from '../../../utils/routes';

export function BillingModal() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const open = useAppSelector((s) => s.billing.modal_open);
    const status = useAppSelector(selectBillingStatus);
    const threshold = useAppSelector(selectThresholdWarning);
    const forecastDays = useAppSelector(selectForecastDays);
    const balance = useAppSelector(selectBillingBalance);
    const unit = useAppSelector(selectBillingUnit);

    const handleClose = () => dispatch(closeBillingModal());

    const handleTopup = () => {
        dispatch(closeBillingModal());
        navigate(routes.profile, {state: {tabIndex: 0}});
    };

    if (status === 'restricted') {
        return (
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                    <BlockIcon color="error"/>
                    Баланс исчерпан
                </DialogTitle>
                <DialogContent>
                    <Alert severity="error" sx={{mb: 2}}>
                        Работа сервиса приостановлена. Часть функций недоступна.
                    </Alert>
                    <Typography>
                        Текущий баланс: <b>{balance.toLocaleString('ru-RU')} {unit}</b>
                    </Typography>
                    <Typography sx={{mt: 1}}>
                        Чтобы возобновить полноценную работу, пополните счёт.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Понятно</Button>
                    <Button onClick={handleTopup} variant="contained" color="primary">
                        Пополнить баланс
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    if (status === 'grace' && threshold !== null) {
        const dayWord =
            threshold === 1 ? 'день' : threshold >= 2 && threshold <= 4 ? 'дня' : 'дней';
        return (
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                    <WarningAmberIcon color="warning"/>
                    Баланс заканчивается
                </DialogTitle>
                <DialogContent>
                    <Alert severity="warning" sx={{mb: 2}}>
                        На балансе осталось примерно на <b>{threshold} {dayWord}</b> работы.
                    </Alert>
                    <Typography>
                        Текущий баланс: <b>{balance.toLocaleString('ru-RU')} {unit}</b>
                    </Typography>
                    {forecastDays !== null && (
                        <Typography sx={{mt: 1, color: 'text.secondary'}}>
                            Прогноз: ≈ {forecastDays}{' '}
                            {forecastDays === 1 ? 'день' : forecastDays >= 2 && forecastDays <= 4 ? 'дня' : 'дней'}
                        </Typography>
                    )}
                    <Typography sx={{mt: 1}}>
                        Пополните баланс, чтобы избежать блокировки.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Позже</Button>
                    <Button onClick={handleTopup} variant="contained" color="primary">
                        Пополнить баланс
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    return null;
}